import { UrlConfig } from '@shared/config/url.config';

export class SmicConfig {
  private static smic: string = UrlConfig.urlAdmin + 'smic';

  public static get smicList(): string {
    return SmicConfig.smic;
  }
}
